import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-current-trip-breadcrumb-card',
  templateUrl: './mcommerce-current-trip-breadcrumb-card.component.html',
  styleUrls: ['./mcommerce-current-trip-breadcrumb-card.component.scss']
})
export class McommerceCurrentTripBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
